const _LOCAL_CAPTCHA = {
    local: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
    rewe: {
        key: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
        lang: "de"
    },
    kaufland: {
        key: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
        lang: "de"
    },
    muller: {
        key: "6LfWEs8ZAAAAABdXUIRvUbcVHid8KRgbfAQGvZtA",
        lang: "de"
    },
    edeka: {
        key: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
        lang: "de"
    },
    netto: {
        key: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
        lang: "de"
    },
    alle: {
        key: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
        lang: "de"
    },
    budni: {
        key: "6Lct-o4oAAAAAJTCtZTlhefMH7DRVHBO2SYkUNPF",
        lang: "de"
    },
    gluecksrad: {
        key: "6Lf5Q8sqAAAAACPMMQQcbtezKwBcRTuvN3wQ38Qp",
        lang: "de"
    },
}

export default _LOCAL_CAPTCHA;